import React, { useState, useEffect } from 'react';
import Container from 'shared/container';
import Headline from 'shared/headline';
import Button from 'button';
import Img from 'shared/img';
import Icon from 'shared/icon';
import { qualityColor, numberKorM } from 'utils/helpers';
import Cookies from 'js-cookie';
import axios from 'axios';
import s from './hero.module.scss';

function QualityBox({ quality }) {
  const dashedO = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="28"
      viewBox="0 0 18 28"
      style={{ overflow: 'visible' }}
    >
      <defs>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html: `
          @import
          url('https://fonts.googleapis.com/css?family=Suranna');
          tspan{
            font-family: 'Suranna', serif!important;
            font-size: 37.605px;
            letter-spacing: -0.02em;
          }
          `
          }}
        />
      </defs>
      <g id="Group_53" data-name="Group 53" transform="translate(-922.455 -96)">
        <text id="o" transform="translate(922.455 122)" fill="#fff">
          <tspan x="0" y="0">
            o
          </tspan>
        </text>
        <path
          id="Path_17"
          data-name="Path 17"
          d="M931.156,162.8a.75.75,0,0,1-.807-.676V139.554a.82.82,0,0,1,1.614,0v22.573A.75.75,0,0,1,931.156,162.8Z"
          transform="translate(0 -36.396)"
          fill="#fff"
        />
      </g>
    </svg>
  );
  return (
    <div className={`${s.qualityBox} ${s[qualityColor(quality)]}`}>
      <span className={s.qualityNumber}>{quality}</span>
      <span className={s.totalNumber}>of 100</span>
    </div>
  );
}

function InfluencersHero({
  firstName,
  lastName,
  username,
  country,
  category,
  featuredImage,
  images,
  followers = 'MISSING',
  ...props
}) {
  const countryName = country && country.name;
  const [blockRequest, setBlockRequest] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true);
  const [connectionError, setConnectionError] = useState(false);

  async function requestAudit() {
    const a = 5;
    if (!blockRequest) {
      setLoading(true);
      try {
        await axios.post(
          'https://us-central1-furlough-main.cloudfunctions.net/auditRequest',
          {
            id: username.replace('@', '')
          }
        );
        Cookies.set(`furlough-auditRequest-${username}`, 'true', {
          expires: a
        });
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          setBlockRequest(true);
        }, 5000);
        setLoading(false);
      } catch (e) {
        console.log(e.message);
        setConnectionError(true);
        setTimeout(() => setConnectionError(false), 5000);
        setLoading(false);
      }
    }
  }
  useEffect(() => {
    if (Cookies.get(`furlough-auditRequest-${username}`)) {
      setBlockRequest(true);
    }
    setInitializing(false);
  }, []);

  const buttonContent = () => {
    if (initializing) return 'Request Audit';
    if (blockRequest) return 'Thanks for your request';
    if (loading) {
      return (
        <span className={s.spinner}>
          <Icon icon="spinner" className="animate-spin" />
        </span>
      );
    }
    if (success) return 'Success!';
    return 'Request Audit';
  };

  return (
    <>
      <Container className={s.root}>
        <div className={s.bgOverlay} />
        <div className={s.backgroundWrapper}>
          <Img
            className={s.bgImg}
            src={(images && images[0]?.id) || 'placeholder-dark'}
          />
        </div>
        <div className={s.flex}>
          <div className={s.column1}>
            <Img
              className={s.featuredImage}
              src={featuredImage?.id}
              alt={featuredImage?.title}
            />
          </div>
          <div className={s.column2}>
            <div className={s.row1}>
              <Headline h2 className={s.influencerName}>
                {`${firstName} ${lastName}`}
              </Headline>
              {countryName && (
                <div className={s.location}>
                  <Icon icon="location-outlined" />
                  {countryName}
                </div>
              )}
              <div className={`${s.flex} ${s.noSpace} ${s.mobileFlex}`}>
                <div
                  className={`${s.userDetails} ${
                    countryName ? s.hasCountry : ''
                  }`}
                >
                  <a
                    className={s.username}
                    href={`https://www.instagram.com/${username.replace(
                      '@',
                      ''
                    )}/`}
                  >
                    <Icon icon="instagram" />
@
                    {username}
                  </a>
                  <span>
                    Followers
                    <strong>{numberKorM(followers)}</strong>
                  </span>
                </div>
                <QualityBox quality="??" color={category?.name} />
              </div>
            </div>
            <div className={s.row2}>
              <p
                className={s.text1}
                dangerouslySetInnerHTML={{ __html: 'Want to view insights?' }}
              />
              <p
                className={s.text2}
                dangerouslySetInnerHTML={{
                  __html:
                    'Audience insights for this influencer is currently unavailable.'
                }}
              />
              <Button
                onClick={requestAudit}
                className={s.button}
                disabled={blockRequest || success || initializing}
              >
                {buttonContent()}
              </Button>
              {connectionError && (
                <p className="error">
                  There was an error processing your request, please try again
                  in a few minutes.
                </p>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
export default InfluencersHero;
